import React from 'react';
import MarkdownCell from '@/components/table/MarkdownCell';

const VocabularyMarkdownCell = ({ vocabulary }) => (
  <MarkdownCell className="td-description" title={vocabulary.value} value={vocabulary.value} />
);

export default VocabularyMarkdownCell;
